import { apiSlice } from "api/apiSlice";

import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";

const distributerAdapter = createEntityAdapter({})

const initialState = distributerAdapter.getInitialState()

export const distributerApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDistributers: builder.query({
            query: params => ({ url: `distributers`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedDistributer = responseData.distributers.map( distributer => {
                    const newDistributer = distributer;
                    newDistributer.active = distributer.active === 1 ? true : false;
                    return newDistributer;
                });
                
                initialState.distributersDetails = {
                    ...initialState.distributersDetails,
                        page: responseData.page,
                        filters: responseData.filters ,
                        distributersPerpage: responseData.distributersPerpage,
                        total_results: responseData.total_results
                }

                return distributerAdapter.setAll(initialState, loadedDistributer)     
            },
            /* eslint-disable */
            providesTags: (result, error, id) => // [{ type: 'Distributer', arg }]
             {
                /* eslint-disable */
                if (result?.ids) {
                    return [
                        { type: 'Distributer', id: 'PARTIAL-LIST' },
                        ...result.ids.map(id => ({ type: 'Distributer', id }))
                    ]
                } else return [{ type: 'Distributer', id: 'PARTIAL-LIST' }]
            }
        }),
        getAutoCompleteDistributers: builder.query({
            query: params => ({ url: `/distributers`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedDistributer = responseData.distributers.map( distributer => {
                    const newDistributer = {}
                    newDistributer.id = distributer.id;
                    newDistributer.name = distributer.companyName !=="" ? distributer.companyName : distributer.displayName;
                    newDistributer.active = distributer.active ;
                    return newDistributer;
                });

                return loadedDistributer;
            },
        }),
        getUserDistributer: builder.query({
            query: userId => ({ url: `userDistributer/${userId}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedDistributer = responseData;
                return loadedDistributer
            },
            /* eslint-disable */
            providesTags: (result, error, args) => [{ type: 'Distributer', id : args.userId }],
        }),
        getDistributerById: builder.query({
            query: (id) => ({ url: `distributer/${id}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedDistributer = responseData;
                return loadedDistributer
            },
            /* eslint-disable */
            providesTags: (result, error, id) => [{ type: 'Distributer', id }],
        }),
        addNewDistributer: builder.mutation({
            query: initialDistributerData => ({
                url: '/distributer',
                method: 'POST',
                body: {
                    ...initialDistributerData,
                }
            }),
            invalidatesTags: [
                { type: 'Distributer', id: "LIST" }
            ]
        }),
        updateDistributer: builder.mutation({
            query: initialDistributerData => ({
                url: '/distributer',
                method: 'PATCH',
                body: {
                    ...initialDistributerData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Distributer', id: arg.id }
            ]
        }),
        updateDistributerPhoto: builder.mutation({
            query: initialDistributerData => ({
                url: '/distributer/upload',
                method: 'POST',
                body: initialDistributerData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Distributer', id: arg.id }
            ]
        }),
        deleteDistributerPhoto: builder.mutation({
            query: initialDistributerData => ({
                url: '/distributer/upload',
                method: 'DELETE',
                body: initialDistributerData,
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Distributer', id: arg.id }
            ]
        }),
        deleteDistributer: builder.mutation({
            query: ({ id }) => ({
                url: `/distributer`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Distributer', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetDistributersQuery,
    useGetUserDistributerQuery,
    useLazyGetAutoCompleteDistributersQuery,
    useLazyGetUserDistributerQuery,
    useGetDistributerByIdQuery,
    useLazyGetDistributerByIdQuery,
    useAddNewDistributerMutation,
    useUpdateDistributerMutation,
    useUpdateDistributerPhotoMutation,
    useDeleteDistributerPhotoMutation,
    useDeleteDistributerMutation,
} = distributerApiSlice

// returns the query result object
export const selectDistributerResult = distributerApiSlice.endpoints.getDistributers.select()

// creates memoized selector
const selectDistributerData = createSelector(
    selectDistributerResult,
    distributerResult => distributerResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllDistributers,
    selectById: selectDistributerById,
    selectIds: selectDistributerIds
    // Pass in a selector that returns the distributer slice of state
} = distributerAdapter.getSelectors(state => selectDistributerData(state) ?? initialState)

export const selectDistributerByUser = createSelector(
    [selectAllDistributers,(state, userId) => userId],
    (distributers, userId) => distributers.find(distributer => distributer.userId === userId)
);